import moment from 'moment';
import { getAll } from '../../api';

// initial users state
const state = {
  rentalDetails: false, // modal boolean
  rentalData: {
    setOne: [],
    setTwo: [],
    setThree: [],
  },
};

// getters
const getters = {
  getRentalDetails(state) {
    return state.rentalDetails;
  },
  getRentalData(state) {
    return state.rentalData;
  },
};

// actions
const actions = {
  acquireRentalData: async ({ commit, rootState, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/session?query=${
        encodeURIComponent(
          `{get(type_name: "session", 
            uuid: ${payload.id}, 
            table_name:"${clientTable}", 
          ){
            uuid, 
            error, 
            success
          }}`,
        )}`,
    )
      .then((res) => {
        commit('setRentalData', {
          data: res.data.getSession,
          clientId: rootState.account.currentClient.id.toString(),
        });
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  }),
};

// mutations
const mutations = {
  setRentalDetails(state, payload) {
    state.rentalDetails = payload;
  },
  setRentalData(state, payload) {
    state.rentalData.setOne = payload.clientId !== 'fcfc2d56-1de2-4ee5-903f-3d9de50ed913'
      ? [
        {
          title: 'Instance ID',
          value: payload.data.id.substring(0, 5),
        },
        {
          title: 'RA#',
          value: payload.data.rental_agreement_number,
        },
        {
          title: 'Device Number',
          value: payload.data.screen.device_id,
        },
        {
          title: 'Version',
          value: payload.data.screen.version,
        },
        {
          title: 'Originating Store',
          value: payload.data.group.name,
        },
      ]
      : [
        {
          title: 'Instance ID',
          value: payload.data.id.substring(0, 5),
        },
        {
          title: 'Device Number',
          value: payload.data.screen.device_id,
        },
        {
          title: 'Version',
          value: payload.data.screen.version,
        },
        {
          title: 'Originating Store',
          value: payload.data.group.name,
        },
      ];
    state.rentalData.setTwo = [
      {
        title: 'Rental Status',
        value: payload.data.screen.session_status,
      },
      {
        title: 'Check Out Started',
        value: payload.data.start_at
          ? moment(payload.data.start_at).format('MM-DD-YYYY h:mmA')
          : '',
      },
      {
        title: 'Checked Out',
        value: payload.data.start_at
          ? moment(payload.data.start_at).format('MM-DD-YYYY h:mmA')
          : '',
      },
      {
        title: 'Checked In',
        value: payload.data.end_at
          ? moment(payload.data.end_at).format('MM-DD-YYYY h:mmA')
          : '',
      },
      {
        title: 'Expected Due Date',
        value: payload.data.expected_end_at
          ? moment(payload.data.expected_end_at).format('MM-DD-YYYY h:mmA')
          : '',
      },
    ];
    state.rentalData.setThree = [
      {
        title: 'Destination Store',
        value: payload.data.destination ? payload.data.destination.name : '',
      },
      {
        title: 'Store Contact',
        value: payload.data.group.contact_name,
      },
      {
        title: 'Store Phone Number',
        value: payload.data.group.contact_phone,
      },
      {
        title: 'Store SPM Email',
        value: payload.data.group.contact_email,
      },
    ];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
